import { initializeApp } from 'firebase/app';
import { initializeFirestore, memoryLocalCache, connectFirestoreEmulator } from 'firebase/firestore';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';
import { getMessaging, isSupported } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

const app = initializeApp(firebaseConfig);

// memoryLocalCache avoids IndexedDB persistence entirely — the SDK no longer
// tries to write/read from a local cache that may contain corrupted entries
// (null-valued position fields cause "Cannot read properties of null
// (reading 'indexOf')" when the SDK applies mutations to the cached document).
export const db = initializeFirestore(app, {
  ignoreUndefinedProperties: true,
  localCache: memoryLocalCache(),
});
export const auth = getAuth(app);
// Röktest mot Firebase-emulatorn (scripts/flatbox-leads-smoke). Byggkonstant –
// sätts bara av testets bygge, aldrig i Netlify eller lokala .env-filer.
if (process.env.REACT_APP_FIREBASE_EMULATOR === 'true') {
  connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
  connectFirestoreEmulator(db, '127.0.0.1', 8080);
}
export const storage = getStorage(app);
export const functions = getFunctions(app, 'europe-north1');

// FCM — bara i webbläsare som stödjer det
export const messaging = (async () => {
  if (await isSupported()) return getMessaging(app);
  return null;
})();

export default app;